if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
/* Zkraze: product gallery prev/next arrows + zoom popup fit/close fix */
(function () {
  if (window.__zkGalleryFix) return;
  window.__zkGalleryFix = true;

  var css =
    '.product-media-modal__content img{width:auto!important;max-width:100%!important;max-height:calc(100vh - 4rem);object-fit:contain;display:block;margin-left:auto!important;margin-right:auto!important;}' +
    '.product-media-modal__toggle{background:#fff!important;color:#111!important;border:.1rem solid rgba(0,0,0,.35)!important;width:4.4rem!important;height:4.4rem;z-index:10!important;right:2rem!important;top:2rem!important;box-shadow:0 .2rem 1rem rgba(0,0,0,.5);}' +
    '.product-media-modal__toggle:hover{color:#000!important;}' +
    '.zk-gallery-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:4;width:4rem;height:4rem;padding:0;border-radius:50%;border:.1rem solid rgba(255,255,255,.35);background:rgba(0,0,0,.6);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;}' +
    '.zk-gallery-arrow:hover{background:rgba(0,0,0,.85);}' +
    '.zk-gallery-arrow--prev{left:1rem;}.zk-gallery-arrow--next{right:1rem;}' +
    '.zk-gallery-arrow svg{width:1.8rem;height:1.8rem;pointer-events:none;}' +
    '@media screen and (max-width:749px){.zk-gallery-arrow{width:3.4rem;height:3.4rem;}.zk-gallery-arrow--prev{left:.6rem;}.zk-gallery-arrow--next{right:.6rem;}}';
  var style = document.createElement('style');
  style.id = 'zk-gallery-fix-css';
  style.textContent = css;
  document.head.appendChild(style);

  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function makeArrow(dir, label, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'zk-gallery-arrow zk-gallery-arrow--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = dir === 'prev' ? ICON_PREV : ICON_NEXT;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    });
    return b;
  }

  function init(gallery) {
    if (gallery.dataset.zkArrows) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;
    var items = thumbs.querySelectorAll('[data-target]');
    if (items.length < 2) return;
    gallery.dataset.zkArrows = 'true';

    if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';

    function go(step) {
      var list = Array.prototype.slice.call(thumbs.querySelectorAll('[data-target]'));
      var current = 0;
      list.forEach(function (li, i) {
        var btn = li.querySelector('button');
        if (btn && btn.hasAttribute('aria-current')) current = i;
      });
      var next = (current + step + list.length) % list.length;
      var nextBtn = list[next].querySelector('button');
      if (nextBtn) nextBtn.click();
    }

    viewer.appendChild(makeArrow('prev', 'Previous image', function () { go(-1); }));
    viewer.appendChild(makeArrow('next', 'Next image', function () { go(1); }));
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
})();